import { useState, useEffect } from "react";

/**
 * Custom hook to detect if the device is mobile
 * @param breakpoint - Custom breakpoint in pixels (default: 768px)
 * @returns {boolean | null} true if mobile, false if desktop, null if not yet determined
 */
const useMobileDetect = (breakpoint: number = 768): boolean | null => {
  const [isMobile, setIsMobile] = useState<boolean | null>(null);

  useEffect(() => {
    const checkMobile = () => {
      if (typeof window !== "undefined") {
        const visualWidth = window.visualViewport?.width || window.innerWidth;
        const mobile = visualWidth < breakpoint;
        setIsMobile(mobile);
      }
    };

    checkMobile();

    const mediaQuery = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    mediaQuery.addEventListener("change", checkMobile);
    window.addEventListener("resize", checkMobile);
    window.addEventListener("orientationchange", checkMobile);

    return () => {
      mediaQuery.removeEventListener("change", checkMobile);
      window.removeEventListener("resize", checkMobile);
      window.removeEventListener("orientationchange", checkMobile);
    };
  }, [breakpoint]);

  return isMobile;
};

export default useMobileDetect;
